import { render, staticRenderFns } from "./PCBuilderAMD.vue?vue&type=template&id=da939ad4&"
import script from "./PCBuilderAMD.vue?vue&type=script&lang=js&"
export * from "./PCBuilderAMD.vue?vue&type=script&lang=js&"
import style0 from "./PCBuilderAMD.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports